import React from 'react';

export default function StatCard({ label, value, sub, icon, iconClass }) {
  return (
    <div className="stat">
      <div className="label">{label}</div>
      <div className="value">{value}</div>
      {sub && <div className="sub">{sub}</div>}
      <div className={`icon ${iconClass || ''}`} aria-hidden="true">
        {icon}
      </div>
    </div>
  );
}
